import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { ForgotPassword, changePassword } from "../api";
import { HEADERS } from "../api";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi"; // Assuming you are using react-icons package
import logo from "../../images/DK_logo.png";

const ResetPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false); // State to control visibility of additional fields
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleGetCode = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        ForgotPassword,
        { email },
        {
          headers: HEADERS,
        }
      );

      if (response.data.response_code === "0000") {
        Swal.fire({
          title: "Success",
          text: response.data.response_description,
          icon: "success",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
            cancelButton: "swal-custom-cancel-btn",
          },
        });
        console.log("res", response);
        setIsCodeSent(true);
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.response_description,
          icon: "error",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
            cancelButton: "swal-custom-cancel-btn",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      Swal.fire({
        title: "Error",
        text: "Passwords do not match.",
        icon: "error",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
      return;
    }

    try {
      const response = await axios.post(
        changePassword,
        {
          user_email: email,
          pass_code: otp,
          new_password: newPassword,
          confirm_new_password: confirmPassword,
        },
        {
          headers: HEADERS,
        }
      );
      console.log("response", response);

      if (response.data.response_code === "0000") {
        Swal.fire({
          title: "Success",
          text: "Your password has been reset successfully.",
          icon: "success",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
            cancelButton: "swal-custom-cancel-btn",
          },
        }).then(() => {
          navigate("/login");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.response_description,
          icon: "error",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
            cancelButton: "swal-custom-cancel-btn",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    }
  };

  return (
    <>
      <div className=" registration-form-container ">
        <a href="." className="logo">
          <img src={logo} alt="Time Trek" height="60" />
        </a>
        <div className="row d-flex flex-column red">
          <div className="col-md-12">
            <div className="registration-form shadow">
              <div className="justify-content-center d-flex">
                <h5 className="title">Password Reset</h5>
              </div>
              <form className="d-flex flex-column mt-2">
                {!isCodeSent && (
                  <div className="row d-flex">
                    <div className="form-group d-flex flex-row">
                      <div className="col-12">
                        <label>Email</label>
                        <input
                          className="form-control"
                          type="email"
                          placeholder="Enter email address"
                          value={email || ""} // Ensure email is always a string
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <button className="get-otp" onClick={handleGetCode}>
                        <span>Get Code</span>
                      </button>
                    </div>
                  </div>
                )}
                {isCodeSent && (
                  <>
                    <div className="form-group d-flex flex-column">
                      <label>One Time Password (OTP)</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter OTP"
                        value={otp || ""}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                      />
                    </div>
                    <div
                      className="form-group d-flex flex-column"
                      style={{ position: "relative" }}
                    >
                      <label>New Password</label>
                      <input
                        className="form-control"
                        type={showNewPassword ? "text" : "password"}
                        placeholder="Enter new password"
                        value={newPassword || ""}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                      {newPassword && (
                        <span
                          style={{
                            position: "absolute",
                            top: "60%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                          {showNewPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                      )}
                    </div>
                    <div
                      className="form-group mt-2 d-flex flex-column"
                      style={{ position: "relative" }}
                    >
                      <label>Confirm Password</label>
                      <input
                        className="form-control"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm password"
                        value={confirmPassword || ""}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      {confirmPassword && (
                        <span
                          style={{
                            position: "absolute",
                            top: "60%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                      )}
                    </div>

                    <button
                      className="button mt-3 add-button justify-content-center"
                      style={{ width: "100%" }}
                      onClick={handleSubmit}
                    >
                      Reset Password
                    </button>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordForm;
